<div class="lightbox-backdrop" (click)="onBackdropClick($event)">
  <div
    class="lightbox"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="alt()"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
  >
    <button class="lightbox__close" type="button" (click)="onClose()" aria-label="Cerrar">
      <app-icon [icon]="closeIcon" [size]="20" />
    </button>

    @if (hasMultiple()) {
      <button
        class="lightbox__nav lightbox__nav--prev"
        type="button"
        (click)="prev(); $event.stopPropagation()"
        aria-label="Imagen anterior"
      >
        <app-icon [icon]="prevIcon" [size]="28" />
      </button>

      <button
        class="lightbox__nav lightbox__nav--next"
        type="button"
        (click)="next(); $event.stopPropagation()"
        aria-label="Siguiente imagen"
      >
        <app-icon [icon]="nextIcon" [size]="28" />
      </button>

      <span class="lightbox__counter">
        {{ currentIndex() + 1 }} / {{ totalImages() }}
      </span>
    }

    <div class="lightbox__image-wrap" [attr.data-variant]="variant()">
      @if (flipAvailable()) {
        <div
          class="lightbox__flip-container"
          [class.lightbox__flip-container--flipped]="isFlipped()"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Voltear ' + alt()"
          (click)="toggleFlip()"
          (keydown.enter)="toggleFlip(); $event.preventDefault()"
          (keydown.space)="toggleFlip(); $event.preventDefault()"
        >
          <img
            class="lightbox__image lightbox__face lightbox__face--front"
            [src]="currentImage()"
            [alt]="alt()"
          />
          <img
            class="lightbox__image lightbox__face lightbox__face--back"
            [src]="backImageUrl()!"
            [alt]="alt() + ' — reverso'"
          />
        </div>
        <button
          class="lightbox__flip-btn"
          type="button"
          (click)="toggleFlip(); $event.stopPropagation()"
          aria-label="Voltear carta"
        >
          <app-icon [icon]="rotateIcon" [size]="16" />
          <span>Voltear</span>
        </button>
      } @else {
        <img class="lightbox__image" [src]="currentImage()" [alt]="alt()" />
      }
    </div>

    @if (hasMultiple()) {
      <div class="lightbox__dots" role="tablist" aria-label="Imágenes del producto">
        @for (img of images(); track $index) {
          <button
            class="lightbox__dot"
            type="button"
            role="tab"
            [attr.aria-selected]="$index === currentIndex()"
            [attr.aria-label]="'Ir a imagen ' + ($index + 1)"
            [class.lightbox__dot--active]="$index === currentIndex()"
            (click)="goTo($index); $event.stopPropagation()"
          ></button>
        }
      </div>
    }
  </div>
</div>
